<template>
	<div class="tabBox_wrap sticky_tab">
		<div ref="tabBox" class="tab_box">
			<button
				v-for="(item, index) in props.items"
				:key="index"
				:ref="(el) => setItemRef(el, index)"
				:value="`${replaceSpecialCharsWithUnderbar(item)}tab`"
				class="tab_item tab_scroll"
				:class="[(category === item || (!category && index === 0)) && 'selected', 'container_item']"
				@click="onClickTab(item)"
			>
				<p>{{ item }}</p>
			</button>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ComponentPublicInstance, ref, watch } from 'vue';

import { replaceSpecialCharsWithUnderbar } from '@/utils/function/format';

// -----variable-----
const props = defineProps<{
	items: string[];
	auth?: boolean;
	selectedScrollTab?: string;
}>();

const emit = defineEmits(['update:category']);

// -----variable-----
const tabBox = ref<HTMLDivElement>();
const refsArray = ref<HTMLElement[]>([]);
const category = ref<string>('');

// -----function-----
// HTML 요소를 중앙에 위치시키는 함수
const scrollToCenter = (element: HTMLElement) => {
	if (tabBox.value) {
		const container = tabBox.value;
		const containerWidth = container.clientWidth;
		const elementWidth = element.clientWidth;
		const elementLeft = element.offsetLeft;
		const scrollPosition = elementLeft - containerWidth / 2 + elementWidth / 2;
		container.scrollTo({
			left: scrollPosition,
			behavior: 'smooth',
		});
	}
};

// 탭 클릭 시 실행 함수
const onClickTab = (tab: string) => {
	if (tabBox.value) {
		category.value = tab;
		const tabElement = tabBox.value.querySelector<HTMLElement>(
			`.container_item[value="${replaceSpecialCharsWithUnderbar(category.value)}tab"]`
		);
		if (tabElement) {
			scrollToCenter(tabElement);
		}
	}
	emit('update:category', tab);
};

// 동적으로 Ref 부여하는 함수
const setItemRef = (el: Element | ComponentPublicInstance | null, index: number) => {
	if (el instanceof HTMLButtonElement) refsArray.value[index] = el;
};

// -----composition-----
// 스크롤 이벤트 발생시 실행 함수
watch(
	() => props.selectedScrollTab,
	() => {
		category.value = props.selectedScrollTab || '';
		if (tabBox.value) {
			const tabElement = tabBox.value.querySelector<HTMLElement>(
				`.container_item[value="${replaceSpecialCharsWithUnderbar(category.value)}tab"]`
			);
			if (tabElement) {
				scrollToCenter(tabElement);
			}
		}
	}
);
</script>

<style lang="scss" scoped>
.tabBox_wrap {
	display: flex;
	justify-content: space-between;
	gap: 1rem;
	border-bottom: 1px solid #393d45;
	position: sticky;
	top: -0.1rem;
	background-color: var(--color-bg);
	z-index: 2;
}

.tab_box {
	display: flex;
	flex-direction: row;
	max-width: 68rem;
	overflow: scroll;
	width: 100%;
	.tab_item {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 0.8rem;
		width: 100%;
		height: 5.2rem;
		white-space: nowrap;
		padding: 0rem 1.6rem;
		@media screen and (max-width: 1280px) {
			padding: 1.6rem 2rem;
		}
		img {
			width: 2.4rem;
			height: 2.4rem;
		}
		p {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-medium);
			line-height: 1.7;
		}
	}
	.selected {
		border-bottom: 1px solid var(--color-primary);
		color: var(--color-primary);
	}
}

.tab_box::-webkit-scrollbar {
	display: none;
}

.tab_allItem {
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	position: absolute;
	top: 103%;
	right: 0;
	z-index: 89;
	background-color: var(--color-bg-mid);
	padding: 2.4rem;
	border-radius: 0.8rem;
	box-shadow: 4px 4px 10px 0px #0000004d;
	@media screen and (max-width: 1280px) {
		margin: 0 2rem;
	}

	.allItem_title {
		font-size: var(--font-s-large);
		font-weight: var(--font-w-semi-bold);
	}
	.allItem_content {
		display: flex;
		flex-wrap: wrap;
		gap: 1rem;
		.content_menu {
			font-size: var(--font-s-mid);
			font-weight: var(--font-w-medium);
			line-height: 1.79rem;
			white-space: nowrap;
			padding: 1.3rem 1.6rem;
			border: 1px solid var(--color-base-mid);
			border-radius: 6px;
		}
	}
}
.dimmed {
	position: fixed;
	background-color: #171616bf;
	top: 0px;
	left: 0px;
	height: 100%;
	width: 100%;
	z-index: 80;
}
</style>
